import type { CollectionItem, CollectionItemWithMarketplaceItem } from "@/services/collection/item/collectionItemTypes";

export function assertHasMarketplaceItem(item: CollectionItem): asserts item is CollectionItemWithMarketplaceItem {
  if (item.marketPlaceItem === null) {
    throw new Error("Item has no marketplace item");
  }
}
